import {
   CurrentHealthcareProviderInvoiceDataQuery,
   HealthcareProviderInvoiceData,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { invoiceSharedTranslationKeys } from '../../../translations';

type InvoiceCreateAccountFormRenderProps = {
   currentHealthcareProviderInvoiceData: HealthcareProviderInvoiceData;
};

type InvoiceCreateAccountFormLoaderProps = {
   readonly children: (renderProps: InvoiceCreateAccountFormRenderProps) => JSX.Element;
};

export const InvoiceCreateAccountFormLoader = (props: InvoiceCreateAccountFormLoaderProps): JSX.Element => {
   const {
      data: currentHealthcareProviderInvoiceData,
      loading: currentHealthcareProviderInvoiceDataLoading,
      error: currentHealthcareProviderInvoiceDataError,
   } = useCqrsGet<HealthcareProviderInvoiceData>(() => new CurrentHealthcareProviderInvoiceDataQuery());

   if (currentHealthcareProviderInvoiceDataLoading) {
      return <LoaderSpinner />;
   }

   if (currentHealthcareProviderInvoiceDataError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={invoiceSharedTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      currentHealthcareProviderInvoiceData: currentHealthcareProviderInvoiceData,
   });
};
